<template>
  <AuthLayout
    active-tab="login"
    title="Köszöntünk a kényelmes<br>könyvelés világában!"
  >
    <form class="auth-form forgotten-form" @submit.prevent="passwordReset">
      <div class="auth-field">
        <label for="forgotten-email">Email</label>
        <input
          v-model="email"
          id="forgotten-email"
          type="email"
          placeholder="Add meg az email címed"
          autocomplete="email"
          required
        />
      </div>

      <button class="auth-submit" type="submit">Új jelszót kérek</button>
    </form>
  </AuthLayout>
</template>

<script>
import Api from "api-client";
import AuthLayout from "@/components/AuthLayout.vue";
import Util from "@/utils/Util";

export default {
  name: "ForgottenPassword",
  components: { AuthLayout },
  data() {
    return {
      email: "",
    };
  },
  methods: {
    passwordReset() {
      let self = this;

      Api.forgotPasswordPwa(this.email)
        .then((resp) => {
          if (resp.status !== 200) {
            self.$toast.error({
              title: self.$cte("common.error"),
              message: self.$cte("login.failedPasswordReset"),
            });
          } else {
            self.$router.push("/login");
            self.$toast.success({
              title: self.$cte("login.pwResetSuccess"),
              message: self.$cte("login.successfulPasswordReset"),
            });
          }
        })
        .catch(() => {
          self.$toast.error({
            title: self.$cte("login.failedPasswordReset"),
            message: self.$cte("login.failedPasswordReset"),
          });
        });
    },
  },
  created() {
    this.email = Util.getLastSuccessfulLoginEmail();
  },
};
</script>

<style scoped lang="scss">
.auth-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.auth-field label {
  display: block;
  margin: 0 0 10px 24px;
  color: #000;
  font-family: JumperLight, sans-serif;
  font-size: 16px;
  line-height: 1;
}

.auth-field input,
#app .auth-field input {
  width: 100%;
  height: 40px !important;
  margin: 0 !important;
  padding: 0 20px !important;
  border: 1px solid #aebfc7 !important;
  border-radius: 999px !important;
  background: rgba(255, 255, 255, 0.6) !important;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
  color: #252734 !important;
  font-family: Poppins, sans-serif;
  font-size: 15px !important;
}

.auth-submit {
  width: 100%;
  min-height: 60px;
  margin-top: clamp(28px, 5vh, 44px);
  border: 0;
  border-radius: 999px;
  background: #b2ec5d;
  box-shadow: 0 20px 30px rgba(0, 0, 0, 0.1);
  color: #252734;
  font-family: JumperLight, sans-serif;
  font-size: clamp(24px, 1.8vw, 32px);
  line-height: 1;
}

@media (max-width: 576px) {
  .auth-field label {
    margin-left: 16px;
    font-size: 16px;
  }

  .auth-submit {
    min-height: 70px;
    margin-top: 32px;
  }
}
</style>
